// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"I0-z","displaySixCardTiles":"J0-z"};